import * as React from 'react';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import styles from './ModalStories.module.css';
import { useTranslation } from 'react-i18next';

export interface IAppProps {
  stores: string[] | undefined;
  isOpen: boolean;
  onClose: () => void;
}

const ModalStories = (props: IAppProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose, stores } = props;
  return (
    <Modal
      className={styles.modal}
      isOpen={isOpen}
      onClose={() => onClose()}
      headerContent={t('menuDetails.modal.title', { count: stores?.length })}
      bodyContent={
        <div className={styles.body}>
          {stores?.map((storeNumber, idx) => (
            <div className={styles.storeNo} key={storeNumber}>
              {stores?.length === 1 || idx === stores.length - 1 ? `${storeNumber}` : `${storeNumber},`}
            </div>
          ))}
        </div>
      }
      footerContent={
        <div className={styles.buttons}>
          <Button
            style={{ width: '12.5em', display: 'flex', justifyContent: 'center' }}
            variant={ButtonVariants.Primary}
            onClick={() => onClose()}
            type="button"
          >
            {t('common.close')}
          </Button>
        </div>
      }
    />
  );
};
export default ModalStories;
